export interface ILoyaltySettings {
  id: string;
  enablePointsExpiration: boolean;
  daysBeforePointsExpire: null | number;
  howMuchMoneyCustomerSpend: number | null;
  howManyPointsCustomerReceives: number | null;
  allowGetPointsFromAddons: boolean;
  allowGetPointsFromSubscriptions: 1 | 0 | boolean;
}

export interface ILoyaltySettingsUpdate {
  enablePointsExpiration: 1 | 0 | boolean;
  howMuchMoneyCustomerSpend: number;
  howManyPointsCustomerReceives: number;
  countExpiration?: number;
  kindOfCountExpiration?: "days" | "months" | "years";
  daysBeforePointsExpire?: number | null;
  allowGetPointsFromAddons: 1 | 0 | boolean;
  allowGetPointsFromSubscriptions: 1 | 0 | boolean;
}

export interface ILoyaltyHistory {
  id: string;
  userId: string;
  firstname: string;
  lastname: string;
  email: string;
  itemFinalPrice: number;
  discountAmount: number;
  isExpired: boolean;
  expireDate: Date | null;
  numberOfPoints: number;
  chargeType: LoyaltyHistoryChargeTypes;
  dropinReservationId: string | null;
  userSubscriptionId: string | null;
  createdAt: Date;
  isFromReferral: boolean;
}

export enum LoyaltyHistoryChargeTypes {
  Deduction = "Deduction",
  Receive = "Receive",
}
